import * as React from 'react'

export const TwoBarsThickIcon = () => (
  <svg width={14} height={12} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 0a1 1 0 0 0-1 1v2.5a1 1 0 0 0 1 1h11.714a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1Zm0 7.5a1 1 0 0 0-1 1V11a1 1 0 0 0 1 1h11.714a1 1 0 0 0 1-1V8.5a1 1 0 0 0-1-1H1Z"
      fill="currentColor"
    />
  </svg>
)

export default TwoBarsThickIcon
